/* ============================================================
   TÄLU — Blog Científico — interacciones
   IntersectionObserver nativo (sin dependencia de GSAP) para:
   reveals, scroll-spy del TOC, barra de progreso, barras de dato,
   y el "tachado" del mito. Respeta prefers-reduced-motion.
   Progressive enhancement: si esto no corre, el contenido se ve igual.
   2026-06-09
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('.tlc');
  if (!root) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Barra de progreso de lectura --- */
  var bar = document.querySelector('.tlc-progress');
  if (bar) {
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var h = document.documentElement;
        var scrolled = h.scrollTop;
        var max = h.scrollHeight - h.clientHeight;
        var pct = max > 0 ? (scrolled / max) * 100 : 0;
        bar.style.width = pct.toFixed(2) + '%';
        ticking = false;
      });
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Si el usuario prefiere menos movimiento, no animamos (todo ya es visible por CSS). */
  if (reduce) return;

  root.classList.add('tlc-anim-ready');

  /* --- Reveal de elementos --- */
  var revealEls = root.querySelectorAll('.tlc-reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          /* animar barras de dato dentro del elemento */
          var bars = e.target.querySelectorAll('.tlc-bar[data-w]');
          bars.forEach(function (b) { b.style.width = b.getAttribute('data-w'); });
          /* animar tachado del mito */
          var strikes = e.target.querySelectorAll('.tlc-myth__m .strike');
          strikes.forEach(function (s) { s.style.setProperty('--tlc-strike', '0'); requestAnimationFrame(function(){ s.style.transition = 'transform .5s ease .15s'; s.style.setProperty('--tlc-strike', '1'); }); });
          obs.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px 0px 0px', threshold: 0.04 });
    revealEls.forEach(function (el) { io.observe(el); });
    /* Red de seguridad: si el observer no disparó en algún bloque, lo mostramos igual (nada queda invisible). */
    setTimeout(function () { revealEls.forEach(function (el) { el.classList.add('is-in'); }); }, 2500);
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* --- Scroll-spy del TOC --- */
  var toc = root.querySelector('.tlc-toc');
  if (toc) {
    var links = Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]'));
    var targets = links.map(function (a) {
      var id = a.getAttribute('href').slice(1);
      return document.getElementById(id);
    }).filter(Boolean);

    if ('IntersectionObserver' in window && targets.length) {
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var id = e.target.id;
            links.forEach(function (a) {
              a.classList.toggle('is-active', a.getAttribute('href') === '#' + id);
            });
          }
        });
      }, { rootMargin: '-80px 0px -70% 0px', threshold: 0 });
      targets.forEach(function (t) { spy.observe(t); });
    }

    /* scroll suave al hacer clic */
    links.forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (!t) return;
        ev.preventDefault();
        var y = t.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }
})();
